import gql from 'graphql-tag';
export const deletePromptMutation = gql `
  mutation deletePrompt($id: UUID!) {
    documentAssistantPrompt: deleteDocumentAssistantPrompt(id: $id) {
      id
    }
  }
`;
